import { DatabaseService } from './database.service';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ObserverService } from './observer.service';
import { APIService } from './api.service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()

export class ParkedCartService {

    constructor(
        public alertController: AlertController,
        private observerService: ObserverService,
        private databaseService: DatabaseService,
        private router: Router,
        private authService: AuthService,
        private apiService: APIService
    ) { }

    addParkedCart(parked_cart) {
        return new Promise<void>((resolve, reject) => {
            if(parked_cart) {
                parked_cart.cart.payments = [];
                if(parked_cart.cart['person'] && parked_cart.cart.person["credit_details"]) {
                    delete parked_cart.cart.person.credit_details;
                }
                if(parked_cart.cart["organisation"] && parked_cart.cart.organisation["credit_details"]) {
                    delete parked_cart.cart.organisation.credit_details;
                }
                this.databaseService.parked_cart.add(parked_cart).then(() => {
                    this.observerService.publish("parked_cart_added", parked_cart);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
            } 
            else {
                reject();
            }
        });
    }

    deleteParkedCart(cart_id) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.parked_cart.delete(cart_id).then(() => {
                this.observerService.publish("parked_cart_deleted", cart_id);
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    deleteParkedCarts() {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.parked_cart.clear().then(() => {
                this.observerService.publish("parked_carts_deleted", null);
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    getParkedCart(parked_cart_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.parked_cart.get(parked_cart_id).then((parked_cart) => {
                resolve(parked_cart);
            })
            .catch(() => {
                reject();
            });
        });
    }

    getParkedCartQuote(parked_cart, format, printer_paper_size) {
        return new Promise((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getParkedCartQuote(parked_cart, format, printer_paper_size).then((parked_cart_quote) => {
                    resolve(parked_cart_quote)
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to get the quote.");
                    }
                    else if(error.status == 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to get a quote.");
                    }
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to get the quote at this time.");
                    }
                    reject();
                })
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    getParkedCarts() {
        return new Promise((resolve, reject) => {
            this.databaseService.parked_cart.toArray().then((parked_carts) => {
                resolve(parked_carts);
            })
            .catch(() => {
                reject();
            });
        });
    }

    updateParkedCart(parked_cart) {
        return new Promise<void>((resolve, reject) => {
            let parked_cart_id = parked_cart.cart.parked_cart_id;
            delete parked_cart.cart.parked_cart_id;
            parked_cart.cart.payments = [];
            this.databaseService.parked_cart.
                update(parked_cart_id, {
                    date: parked_cart['date'],
                    user_id: parked_cart['user_id'],
                    cart: parked_cart['cart']
                })
                .then(() => {
                    // NOTE: this publish() event fires twice for no obvious reason
                    this.observerService.publish("parked_cart_updated", parked_cart_id);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    updateParkedCartLegacyData(parked_cart) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.parked_cart.update(parked_cart['id'], parked_cart).catch(() => {
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ['OK'],
        });
        await alert.present();
    }

}
